export default __webpack_public_path__ + "static/media/gamedev_open.499b3bb9.png";